import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
  Typography,
  Chip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 1.5),
  },
  selectWrap: {
    minWidth: 280,
    width: "100%",
    maxWidth: 520,
    flex: 1,
  },
  meta: {
    color: "#556070",
    whiteSpace: "nowrap",
  },
  select: {
    "& .MuiSelect-select": {
      minHeight: 20,
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: theme.spacing(0.5),
    },
  },
  chip: {
    maxWidth: "100%",
  },
}));

const SeasonSelector = ({ selectedSeasonIds, seasonOptions, onSeasonChange }) => {
  const classes = useStyles();
  const selectedSeasonSet = new Set(selectedSeasonIds);

  const renderValue = (selected) => {
    const values = Array.isArray(selected) ? selected : [];
    if (!values.length) {
      return "未選択";
    }

    if (values.length === 1) {
      const label = seasonOptions.find((option) => option.value === values[0])?.label || values[0];
      return label;
    }

    return (
      <>
        {values.map((value) => {
          const label = seasonOptions.find((option) => option.value === value)?.label || value;
          return (
            <Chip
              key={value}
              size="small"
              label={label}
              className={classes.chip}
            />
          );
        })}
      </>
    );
  };

  return (
    <Box className={classes.root}>
      <Typography variant="body1" className={classes.meta}>
        シーズン：
      </Typography>
      <Box className={classes.selectWrap}>
        <FormControl variant="outlined" fullWidth size="small">
          <Select
            labelId="regular-season-selector-label"
            multiple
            displayEmpty
            className={classes.select}
            value={selectedSeasonIds}
            renderValue={renderValue}
            onChange={onSeasonChange}
          >
            {seasonOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <Checkbox checked={selectedSeasonSet.has(option.value)} />
                <ListItemText primary={option.label} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

SeasonSelector.propTypes = {
  selectedSeasonIds: PropTypes.array.isRequired,
  seasonOptions: PropTypes.array.isRequired,
  onSeasonChange: PropTypes.func.isRequired,
};

export default SeasonSelector;
